// extracted by mini-css-extract-plugin
export default {"viewControls":"ViewControls_viewControls__jwHdg"};